// extracted by mini-css-extract-plugin
module.exports = {"perfil":"Feed_perfil__2nG_7","outside":"Feed_outside__3m-3o"};